import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, ViewEncapsulation } from '@angular/core';
import { MatDialogTransportListData } from 'src/app/interfaces/mat.interface';
import { Transport } from 'src/app/pages/custom-route/interfaces/custom-route.interface';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { DragHandleComponent } from "../../../../../../../../../../shared/drag-handle/drag-handle.component";
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from "./components/header/header.component";
import { MainComponent } from "./components/main/main.component";
import { FooterComponent } from "./components/footer/footer.component";

@Component({
  selector: 'app-all-transport-list',
  standalone: true,
  imports: [
    TranslateModule,
    DragHandleComponent,
    HeaderComponent,
    MainComponent,
    FooterComponent
],
  templateUrl: './all-transport-list.component.html',
  styleUrls: ['./all-transport-list.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  encapsulation: ViewEncapsulation.None
})
export class AllTransportListComponent {
  private _bottomSheetData: MatDialogTransportListData = inject(MAT_BOTTOM_SHEET_DATA, { optional: true });
  
  public getTransportList(): Transport[] {
    if (!this._bottomSheetData?.transportList) return [];
    return this._bottomSheetData.transportList;
  }
  
  public getTransport(): number | undefined {
    if (!this._bottomSheetData?.transportId) return undefined;
    return this._bottomSheetData?.transportId;
  }

  public getTransportId(): number | undefined {
    return this._bottomSheetData?.transportId;
  }
  
  public getPointTitle(): string {
    if (!this._bottomSheetData?.pointTitle) return '';
    return this._bottomSheetData.pointTitle;
  }
  
  public getPreviousPointTitle(): string {
    if (!this._bottomSheetData?.previousPointTitle) return '';
    return this._bottomSheetData.previousPointTitle;
  }
}